module.exports = __webpack_public_path__ + "img/download-icon-active.36fc4b9e.svg";